import { render, staticRenderFns } from "./LastRoundFeedback.vue?vue&type=template&id=d73f79f4&scoped=true&"
import script from "./LastRoundFeedback.vue?vue&type=script&lang=js&"
export * from "./LastRoundFeedback.vue?vue&type=script&lang=js&"
import style0 from "./LastRoundFeedback.vue?vue&type=style&index=0&id=d73f79f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73f79f4",
  null
  
)

export default component.exports